<template>
<div>
    <v-btn bottom color="pink" dark fab fixed right @click="dialog = !dialog">
        <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" width="800px">
        <v-form ref="form" @submit.prevent="añadirAbono([datos, fromDateVal])">
            <v-card>
                <v-card-title class="blue text-uppercase" style="color: #fff;" dark>
                    Solicitud de Abono - {{usuario.isla}}
                </v-card-title>
                <v-container>
                    <v-row class="mx-2">
                        <v-alert
                            border="right"
                            colored-border
                            type="error"
                            elevation="2"
                            v-if="!$v.datos.factura.required || !$v.datos.cliente.required || productosInvalidos || !$v.datos.noEntregadoCliente.required"
                            >
                            Debes Rellenar los campos seleccionados y asegurarte de incluir el Número de Serie de cada producto
                        </v-alert>
                        <v-col md="6" cols="12">
                            <v-text-field counter="11" label="Número de Factura *" v-model="$v.datos.factura.$model"></v-text-field>
                        </v-col>
                        <v-col md="6" cols="12">
                            <v-menu v-model="fromDateMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field label="Fecha" prepend-icon="mdi-event" readonly :value="fromDateVal" v-on="on" required></v-text-field>
                                </template>
                                <v-date-picker locale="en-in" v-model="fromDateVal" no-title @input="fromDateMenu = false" :max="maxDate"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field label="Cliente *" v-model="$v.datos.cliente.$model"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <div class="mb-2">
                                <strong>Artículos a Abonar *</strong>
                            </div>
                            <v-card v-for="(producto, index) in datos.productos" :key="index" class="mb-3" outlined>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" md="3">
                                            <v-text-field 
                                                label="Referencia" 
                                                v-model="producto.referencia"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-text-field 
                                                label="Número de Serie *" 
                                                v-model="$v.datos.productos.$each[index].numeroSerie.$model"
                                                :error-messages="getProductoErrors(index, 'numeroSerie')"
                                                :error="getProductoError(index, 'numeroSerie')"
                                                required
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="5">
                                            <v-text-field 
                                                label="Descripción" 
                                                v-model="producto.descripcion"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="1" class="d-flex align-center">
                                            <v-btn 
                                                icon 
                                                color="error" 
                                                @click="eliminarProducto(index)"
                                                :disabled="datos.productos.length === 1"
                                            >
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                            <v-btn 
                                color="primary" 
                                outlined 
                                @click="agregarProducto"
                                class="mt-2"
                            >
                                <v-icon left>mdi-plus</v-icon>
                                Agregar Producto
                            </v-btn>
                            <div v-if="productosListaErrors.length > 0" class="mt-2">
                                <v-alert type="error" dense text>
                                    {{ productosListaErrors[0] }}
                                </v-alert>
                            </div>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea name="motivo" label="Motivo" hint="Motivo de la Devolución" v-model="datos.motivo" rows="2"></v-textarea>
                        </v-col>
                        <v-col cols="6" md="3">
                            <v-switch label="Precintado" v-model="datos.precintado"></v-switch>
                        </v-col>
                        <v-col cols="6" md="3">
                            <v-switch label="Bajo Pedido" v-model="datos.bajoPedido"></v-switch>
                        </v-col>
                        <v-col cols="6" md="3">
                            <v-switch label="Activo en Web" v-model="datos.activoWeb"></v-switch>
                        </v-col>
                        <v-col cols="6" md="3">
                            <v-switch label="Cambio Precio" v-model="datos.cambioPrecio"></v-switch>
                        </v-col>
                        <v-col cols="12">
                            <v-radio-group v-model="$v.datos.noEntregadoCliente.$model" >
                                <template v-slot:label>
                                    <div>¿El/los artículo/s fueron entregados al cliente? *</div>
                                </template>
                                <v-radio value="Si">
                                    <template v-slot:label>
                                    <div>Si</div>
                                    </template>
                                </v-radio>
                                <v-radio value="No">
                                    <template v-slot:label>
                                    <div>No</div>
                                    </template>
                                </v-radio>
                            </v-radio-group>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field label="Observaciones" v-model="datos.observaciones"></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text color="primary" @click="dialog = false">Cancelar</v-btn>
                    <v-btn text type="submit" @click="dialog = false" :disabled="$v.$invalid">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</div>
</template>

<script>
import {
    mapActions,
    mapState
} from 'vuex';
import { required } from 'vuelidate/lib/validators';
export default {
    props: {
        source: String,
    },
    data: () => ({
        dialog: false,
        fromDateMenu: false,
        fromDateVal: null,
        datos: {
            factura: '',
            observaciones: '',
            cliente: '',
            productos: [
                {
                    referencia: '',
                    numeroSerie: '',
                    descripcion: ''
                }
            ],
            motivo: '',
            precintado: false,
            bajoPedido: false,
            activoWeb: false,
            cambioPrecio: false,
            noEntregadoCliente: null,
        },
        minDate: "2019-07-04",
        maxDate: new Date().toJSON().slice(0, 10).replace(/-/g, '/')
    }),
    validations: {
        datos: {
            factura: {
                required
            },
            cliente: {
                required
            },
            productos: {
                $each: {
                    numeroSerie: {
                        required
                    }
                }
            },
            noEntregadoCliente: {
                required
            }
        }
    },
    computed: {
        fromDateDisp() {
            return this.fromDateVal;
            // format date, apply validations, etc. Example below.
            // return this.fromDateVal ? this.formatDate(this.fromDateVal) : "";
        },
        productosListaErrors() {
            const errors = [];
            if (!this.$v.datos.productos.$dirty) return errors;
            if (this.datos.productos.length === 0) {
                errors.push('Debe agregar al menos un producto');
            }
            this.datos.productos.forEach((producto, index) => {
                if (this.$v.datos.productos.$each[index] && !this.$v.datos.productos.$each[index].numeroSerie.required) {
                    errors.push(`El número de serie es obligatorio en el producto ${index + 1}`);
                }
            });
            return errors;
        },
        productosInvalidos() {
            if (!this.$v.datos.productos.$dirty) return false;
            return this.datos.productos.some((producto, index) => {
                return this.$v.datos.productos.$each[index] && !this.$v.datos.productos.$each[index].numeroSerie.required;
            });
        },
        ...mapState(['usuario', 'roles'])
    },
    methods: {
        ...mapActions(['crearAbono']),
        agregarProducto() {
            this.datos.productos.push({
                referencia: '',
                numeroSerie: '',
                descripcion: ''
            });
        },
        eliminarProducto(index) {
            if (this.datos.productos.length > 1) {
                this.datos.productos.splice(index, 1);
            }
        },
        formatearProductos() {
            // Formatea los productos como "Referencia | Número de Serie | Descripción" separado por <br/>
            return this.datos.productos
                .map(p => {
                    const partes = [];
                    if (p.referencia) partes.push(p.referencia);
                    if (p.numeroSerie) partes.push(p.numeroSerie);
                    if (p.descripcion) partes.push(p.descripcion);
                    return partes.join(' | ');
                })
                .join('<br/>');
        },
        getProductoError(index, campo) {
            if (this.$v.datos.productos.$each[index]) {
                return this.$v.datos.productos.$each[index][campo].$error;
            }
            return false;
        },
        getProductoErrors(index, campo) {
            const errors = [];
            if (this.$v.datos.productos.$each[index] && this.$v.datos.productos.$each[index][campo]) {
                if (campo === 'numeroSerie' && !this.$v.datos.productos.$each[index][campo].required && this.$v.datos.productos.$each[index][campo].$dirty) {
                    errors.push('El número de serie es obligatorio');
                }
            }
            return errors;
        },
        añadirAbono([abono, fecha]) {
            // Formatear productos antes de enviar
            const abonoFormateado = {
                ...abono,
                productos: this.formatearProductos()
            };
            this.crearAbono([abonoFormateado, fecha, this.usuario])
                .then((res) => {
                    setTimeout(() => {
                        this.datos.factura = '';
                        this.datos.observaciones = '';
                        this.datos.cliente = '';
                        this.datos.productos = [
                            {
                                referencia: '',
                                numeroSerie: '',
                                descripcion: ''
                            }
                        ];
                        this.datos.motivo = '';
                        this.datos.precintado = false;
                        this.datos.bajoPedido = false;
                        this.datos.activoWeb = false;
                        this.datos.cambioPrecio = false;
                        this.fromDateVal = null;
                        this.datos.noEntregadoCliente = null;
                        this.$v.$reset();
                    }, 5000)

                }).catch((err) => {
                    console.log(err);
                });
        }
    },
}
</script>
